import {
  componentDefinitionFormConditional,
  ComponentDefinitionFormConditionalType,
  ComponentDefinitionMainDetails,
  componentDefinitionMainDetails,
  formConditionalContainer,
  FormConditionalContainerType,
} from '@/assets/locales/views/componentDefinitions/componentDefinitions.common.translation.pl.ts';
import { ComponentDefinitionDetailsPricesBasicAddFormModel } from '@/views/componentDefinitions/details/components/pricesList/components/basicPrices/components/add/model/ComponentDefinitionDetailsPricesConditionalAddForm.model';

type FormBasicType = Record<keyof ComponentDefinitionDetailsPricesBasicAddFormModel, string>;
const formBasic: FormBasicType = {
  minimumPrice: 'Cena minimalna',
  quantity: 'Liczba minimalna',
  validFrom: 'Ważna od',
  validTo: 'Ważna do',
};

export type ComponentDefinitionDetailsTranslation = {
  main: ComponentDefinitionMainDetails;
  noItems: string;
  prices: {
    basic: {
      form: FormBasicType & {
        button: {
          cancel: string;
          save: string;
        };
      };
      title: string;
    };
    conditional: {
      form: ComponentDefinitionFormConditionalType & {
        button: {
          cancel: string;
          save: string;
        };
      };
      item: {
        details: ComponentDefinitionFormConditionalType;
        main: FormConditionalContainerType;
      };
    };
    dialog: {
      container: {
        button: {
          cancel: string;
          save: string;
        };
        form: FormConditionalContainerType;
        title: {
          create: string;
        };
      };
    };
    table: {
      basic: {
        head: FormBasicType;
      };
    };
    title: string;
  };
};

export const componentDefinitionDetailsTranslation: ComponentDefinitionDetailsTranslation = {
  main: componentDefinitionMainDetails,
  noItems: 'Brak wpisów',
  prices: {
    basic: {
      form: {
        ...formBasic,
        button: {
          cancel: 'Anuluj',
          save: 'Zapisz',
        },
      },
      title: 'Dodaj cenę',
    },
    conditional: {
      form: {
        ...componentDefinitionFormConditional,
        button: {
          cancel: 'Anuluj',
          save: 'Zapisz',
        },
      },
      item: {
        details: componentDefinitionFormConditional,
        main: formConditionalContainer,
      },
    },
    dialog: {
      container: {
        button: {
          cancel: 'Anuluj',
          save: 'Zapisz',
        },
        form: formConditionalContainer,
        title: {
          create: 'Utwórz nowy zestaw',
        },
      },
    },
    table: {
      basic: {
        head: formBasic,
      },
    },
    title: 'Lista cen',
  },
};
